import React from 'react'


import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContactForm from "./ContactForm";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={"div"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `wrapped-tab-${index}`,
        "aria-controls": `wrapped-tabpanel-${index}`,
    };
}

const TabsSwitch = () => {

    const [value, setValue] = React.useState("one");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const styles = {
        marginLeft: "0.2rem",
        backgroundColor: "#f2f2f2" /* Green */,
        color: "grey",
        padding: "15px 32px",
        textAlign: "center",
        textDecoration: "none",
        display: "inline-block",
        fontSize: "16px",

        "&.Mui-selected": {
            backgroundColor: "#FFD700",
            border: "none",
            color: "#333333",
            padding: "15px 32px",
            textAlign: "center",
            textDecoration: "none",
            display: "inline-block",
            fontSize: "16px"

        }
    }
    return (
        <div className="section2 mt-10 sm:w-[40rem] lg:w-[80vw] mx-auto py-8 px-5">

            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="wrapped label tabs example"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { backgroundColor: "white" } }}
            >
                <Tab className="!font-bold !capitalize" value="one" label="technical support" {...a11yProps("two")} sx={styles}  />
                <Tab
                    value="three"
                    label="Sales Inquiry"

                    {...a11yProps("one")}
                    sx={styles}
                    className="!font-bold !capitalize"
                />

            </Tabs>
            <TabPanel value={value} index="one" className="bg-[#FCFCFC]">
                {/* form starts */}
                <ContactForm inquiryType={"tech"} />

                {/* form ends */}
            </TabPanel>
            <TabPanel value={value} index="two" className="bg-[#FCFCFC]">
                {/* form starts */}
                <ContactForm inquiryType={"candidateSupport"} />

                {/* form ends */}
            </TabPanel>
            <TabPanel value={value} index="three" className="bg-[#FCFCFC]">
                {/* form starts */}
                <ContactForm inquiryType={"sales"} />

                {/* form ends */}
            </TabPanel>
        </div>
    )
}

export default TabsSwitch